// extracted by mini-css-extract-plugin
export default {"deleteProfileForm":"styles_deleteProfileForm__MRR78","yesButton":"styles_yesButton__r6cxX"};